module.exports = __webpack_public_path__ + "img/comet-favicon.7acb59a4.png";